import { Check } from '@mui/icons-material'
import { Box, Button, Typography } from '@mui/material'

interface SubscriptionsPlanProps {
  priceId: string
  planId: string
  planName: string
  planType: string
  price: string
  period: string
  features: string[]
  isCurrentPlan: boolean
  planTypeBgColor?: string
  interval: string
  handleMakePayment: (data: any) => void
}

const SubscriptionsPlan = (props: SubscriptionsPlanProps) => {
  const {
    priceId,
    planId,
    planName,
    planType,
    price,
    period,
    features,
    isCurrentPlan,
    planTypeBgColor,
    interval,
    handleMakePayment,
  } = props

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        p: 2,
        minWidth: '300px',
        gap: 1,
        border: '1px solid #E5E5E5',
        background: 'linear-gradient(180deg, #FFFFFF 30.92%, #C8DFFF 100%)',
      }}
    >
      <Box
        sx={{
          p: 1,
          backgroundColor: planTypeBgColor ? planTypeBgColor : '#E5F0FF',
          width: 'fit-content',
        }}
      >
        <Typography>{planType}</Typography>
      </Box>
      <Typography
        sx={{
          fontSize: '20px',
        }}
      >
        {planName}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Typography
          sx={{
            fontSize: '22px',
            fontWeight: 600,
          }}
        >
          {price}
        </Typography>
        <Typography
          sx={{
            color: '#797979',
          }}
        >
          {period}
        </Typography>
      </Box>
      <Box>
        <Typography>Features</Typography>
        {features.map((item) => (
          <Box
            sx={{
              display: 'flex',
              gap: 1,
            }}
          >
            <Check />
            <Typography
              sx={{
                color: '#1705E5',
              }}
            >
              {item}
            </Typography>
          </Box>
        ))}
      </Box>
      <Button
        sx={{
          background: isCurrentPlan ? '#04002E' : '#1705E5',
          color: '#F5F5F5',
          fontSize: '12px',
          textTransform: 'none',
        }}
        onClick={() =>
          handleMakePayment({ planId, planName, priceId, interval })
        }
      >
        {isCurrentPlan ? 'Current Plan' : 'Upgrade'}
      </Button>
    </Box>
  )
}

export default SubscriptionsPlan
